export enum SizeLoading {
    SMALL = 'small',
    MIDDLE = 'middle',
    LARGE = 'large'
}
